import { useEffect, useState } from 'react';
import { useUnit } from 'effector-react';
import { useTranslation } from 'react-i18next';
import { $userCardsStore } from '@lib/store/userManagement';
import { useListState } from '@shared/hooks';
import { CardStatus } from '@shared/api/rest/cards';
import { RelatedCards } from '@widgets';
import { Pagination } from '@shared/widgets';

interface IUserCardsProps {
  userId: string;
}

export const UserCards = (props: IUserCardsProps) => {
  const userCardsStore = useUnit($userCardsStore.store);

  const [allTotal, setAllTotal] = useState<number>(0);
  const [status, setStatus] = useState<CardStatus>();

  const userCardsState = useListState({ list: 'userCards' });

  const { t } = useTranslation();

  useEffect(() => {
    $userCardsStore.events.getUserCards({
      Status: status,
      AssignedUserId: props.userId,
      FromIndex: userCardsState.fromIndex,
      Count: userCardsState.count,
    });
  }, [props.userId, status, userCardsState]);

  useEffect(() => {
    if (status == undefined) setAllTotal(userCardsStore.data.total);
  }, [userCardsStore.data.total]);

  return (
    <>
      <RelatedCards loading={userCardsStore.loading} total={allTotal} cards={userCardsStore.data.data} activeTab={status} setActiveTab={setStatus} />
      {userCardsStore.data.data.length > 0 && (
        <Pagination
          className='mt-5'
          perPageLabel={t('pagination.perPage.items')}
          totalItemCount={userCardsStore.data.total}
          currentPage={userCardsState.page}
          countItemPage={userCardsState.count}
          onChangePage={userCardsState.onChangePage}
          onChangeCountItemPage={userCardsState.onChangeCount}
        />
      )}
    </>
  );
};
